/**
 * Base Transport Interface / Contract
 * Defines the standard lifecycle and communication methods for any realtime protocol.
 * Enables seamless switching between SignalR, uWebSockets.js, and Native WebSockets.
 */
export class IRealtimeTransport {
    /**
     * Connect to the realtime server
     * @param {Object} config - Configuration options (url, token, options)
     * @returns {Promise<void>}
     */
    async connect(config) {
        throw new Error("connect() must be implemented by transport adapter");
    }

    /**
     * Disconnect from the realtime server
     * @returns {Promise<void>}
     */
    async disconnect() {
        throw new Error("disconnect() must be implemented by transport adapter");
    }

    /**
     * Invoke a remote server method with arguments
     * @param {string} methodName - Name of the remote method/action
     * @param {...any} args - Arguments to pass
     * @returns {Promise<any>}
     */
    async invoke(methodName, ...args) {
        throw new Error("invoke() must be implemented by transport adapter");
    }

    /**
     * Subscribe to a server event
     * @param {string} eventName - Name of the event
     * @param {Function} handler - Callback function
     */
    on(eventName, handler) {
        throw new Error("on() must be implemented by transport adapter");
    }

    /**
     * Unsubscribe from a server event
     * @param {string} eventName - Name of the event
     * @param {Function} handler - Callback function
     */
    off(eventName, handler) {
        throw new Error("off() must be implemented by transport adapter");
    }

    /**
     * Get current connection state
     * @returns {string} ConnectionState
     */
    getState() {
        throw new Error("getState() must be implemented by transport adapter");
    }

    /**
     * Get current connection/socket ID
     * @returns {string|null}
     */
    getConnectionId() {
        return null;
    }
}
